/* eslint-disable no-empty */
/* eslint-disable max-len */
/* eslint-disable array-callback-return */
import axios from 'axios';
import {
  LICENSE_LOADING, GET_LICENSES_CUSTOMER, GET_DETAIL_LICENSES_CUSTOMER,
  CLEAR_LICENSES_CUSTOMER, SET_CHIPS_FILTERS_LICENSES, CHANGE_CHIPS_FILTERS_LICENSES,
  ADD_LICENSE_CUSTOMER, GET_CUSTOMER_INFORMATION_LICENSE, GET_LICENSE_INFORMATION, GET_MANAGERS, GET_APP_PARAMETERS_CONTRACTS, GET_CONTRACT_DATA,
  GET_SERVICES_DATA_DASHBOARD,
  GET_DETAIL_CONTRACTS, GET_HISTORY_CONSUMPTION_DASHBOARD, GET_REQUEST_DASHBOARD, GET_CONTRACT_CUSTOMER_INFO, GET_CONTRACT_SUPERVISOR_INFO, GET_CONTRACT_DETAILS,
  GET_AGREEMENTS_LIST, GET_INFORMATION_AGREEMENT, MODIFY_INFORMATION_AGREEMENT, LICENSE_LOADING_UPDATE_AGREEMENT,
  GET_RISK_OFFICERS, GET_CART_SUCCESS, UPDATE_LOCAL_QUANTITY, REMOVE_CART_ITEM, LOADING_MARKET_PLACE, GET_LICENSES_SUCCESS, UPDATE_LICENSE_DATA, DELETE_LICENSE_ASSIGNMENT,
  GET_CART_ERROR, LICENSE_LOADING_SAVE_ORDER, GET_ITEMS_CATALOG, UPDATE_CART_ITEM_FULL, LOADING_LOAD_PRODUCTS_ASSIGNMENTS, LICENSE_SAVE_ORDER_SUCCESS, SET_MARKET_CONTEXT,
  SAVE_ASSIGNMENTS_SUCCESS, SAVING_ASSIGNMENTS_LOADING, SAVE_ORDER_SUCCESS, SAVE_ORDER_MARKET_ERROR, PRODUCT_WAS_ASSIGNED,
  PAYMENT_RESULT, ADD_PROMO_TO_LIST, LOADING_VALIDATE_PROMO_CODE, SET_PROMO_FEEDBACK, LOADING_CONTRACT_CUSTOMER_INFO, LOADING_CONTRACT_SUPERVISOR_INFO,
  COUNTRIES_FLAGS, CUSTOMER_ASSIGNED_CONTRACTS, CLEAR_SERVICES_DATA_DASHBOARD, GET_CUSTOMER_EDIT_INFORMATION_LICENSE, LOADING_CUSTOMER_EDIT_INFORMATION,
  LICENSE_LOADING_UPDATE_CUSTOMER, LOADING_CONTRACT_ANNULMENT, CONTRACT_ANNULMENT,
} from '../types/license.type';
import { setMessageAlertAction } from './general.action';
import {
  API_LICENCIAMIENTO, API_SEGURIDAD, TENANT_LANDINGS, EPAYCOPAYMENTSSERVICES,
} from '../config/config';
import { defaultHeaders, defaultHeadersMarket, sortBy } from '../helpers/generalUtils';
import AddedLicenseSuccessfullyIcon from '../assets/img/iconos/license/AddedLicenseSuccessfullyIcon.svg';

// eslint-disable-next-line import/prefer-default-export
export const getLicenseUsageCustomerAction = (skip, take, filter, dataCustomer) => async (dispatch, getState) => {
  try {
    dispatch({ type: LICENSE_LOADING, payload: true });
    const { license: { licenseCustomer } } = getState();
    const { general: { tenant } } = getState();
    const config = defaultHeaders();
    Object.assign(config.headers, {
      pSkip: skip,
      pTake: take,
    });
    if (tenant) {
      Object.assign(config.headers, { tenant });
    }
    const customer = {
      DocumentType: dataCustomer ? dataCustomer.DocumentType : null,
      DocumentNumber: dataCustomer ? dataCustomer.DocumentNumber : null,
      ServiceName: null,
      pFilter: filter,
    };
    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/license/getLicenseUsage`, customer, config);

    if (response.status === 200) {
      const { records } = response.data.result;
      if (licenseCustomer) Array.prototype.push.apply(licenseCustomer, records.licenseUsageList);
      const arrUpdated = Object.assign([], licenseCustomer.length === 0 ? records.licenseUsageList : licenseCustomer);
      dispatch({
        type: GET_LICENSES_CUSTOMER,
        payload: arrUpdated,
        rownums: records.countRecords,
        nextSkipLicense: records.nextSkipLicense,
      });
      dispatch({ type: LICENSE_LOADING, payload: false });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: LICENSE_LOADING, payload: false });
    dispatch({
      type: GET_LICENSES_CUSTOMER,
      payload: [],
      rownums: 0,
      nextSkipLicense: 0,
    });
  }
};

export const getClearLicensesCustomerAction = () => async (dispatch) => {
  dispatch({
    type: GET_LICENSES_CUSTOMER,
    payload: [],
    rownums: 0,
    nextSkipLicense: 0,
  });
};

export const getCustomerInformationLicenseAction = (Idcustomer, docType, doc) => async (dispatch) => {
  try {
    const config = defaultHeaders();
    // Object.assign(config.headers, {
    //   customerId: Idcustomer,
    //   DocumentType: docType,
    //   DocumentNumber: doc,
    // });

    const data = {
      CustomerId: Idcustomer,
      DocumentNumber: doc.toString(),
      DocumentType: docType.toString(),
    };
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/Customer/GetCustomer`,
      data, config,
    );
    if (response.status === 200) {
      dispatch({
        type: GET_CUSTOMER_INFORMATION_LICENSE,
        payload: response.data,
      });
    }
  } catch (error) {
    console.error(error);
    const { response } = error;
    if (response.status === 404) {
      dispatch({
        type: GET_CUSTOMER_INFORMATION_LICENSE,
        payload: response.data,
      });
    }
  }
};

export const setFiltersLicenseAction = (type, service, customer, optionsFilter) => async (dispatch, getState) => {
  try {
    const { license: { chipsFiltersOptions } } = getState();
    let chipsOptions = chipsFiltersOptions;
    // dispatch({ type: CHANGE_CHIPS_FILTERS_LICENSES, payload: [] });

    if (type === 'Load') {
      // let filtersAux = [];
      // licenses.map((item) => {
      if (customer) {
        if (chipsOptions.filter((x) => x.key === customer.documentNumber).length === 0) {
          const customerFilter = {
            id: customer.CustomerId,
            key: customer.documentNumber,
            type: 'Customer',
            value: customer.customerName,
            default: true,
          };
          chipsOptions.push(customerFilter);
          chipsOptions = chipsOptions.sort(sortBy('type', false, (a) => a.toUpperCase()));
        }
        service.licensePlan.map((license) => {
          if (chipsOptions.filter((x) => x.key === license.serviceId).length === 0) {
            const serviceFilter = {
              id: license.purchaseOrderLicenseId,
              key: license.serviceId,
              type: 'Service',
              value: license.serviceName,
              default: true,
            };
            chipsOptions.push(serviceFilter);
            chipsOptions = chipsOptions.sort(sortBy('type', false, (a) => a.toUpperCase()));
          }
        });
      }
    } else if (type === 'Customer') {
      if (customer) {
        chipsOptions = chipsOptions.filter((x) => x.type !== 'Customer');
        const CustomerFilter = {
          id: customer.id,
          key: customer.id,
          type: 'Customer',
          value: customer.text,
          default: true,
        };
        chipsOptions.push(CustomerFilter);
      }
      chipsOptions = chipsOptions.sort(sortBy('type', false, (a) => a.toUpperCase()));

      dispatch({ type: CHANGE_CHIPS_FILTERS_LICENSES, payload: chipsOptions });
    } else if (type === 'Service') {
      Object.values(optionsFilter).forEach((item) => {
        if (chipsOptions.filter((x) => x.key === item.id && x.type === 'Service').length === 0) {
          if (item.filtered === true) {
            const serviceFilter = {
              id: item.id,
              key: item.id,
              type: 'Service',
              value: item.label,
              default: false,
            };
            chipsOptions.push(serviceFilter);
          }
        } else if (item.filtered === false) {
          const filter = chipsOptions.find((x) => x.id === item.id);
          if (filter?.default === false) {
            chipsOptions = chipsOptions.filter((x) => x.key !== item.id);
          }
        }
      });

      dispatch({ type: CHANGE_CHIPS_FILTERS_LICENSES, payload: chipsOptions });
    }
  } catch (error) {
    console.error(error);
  }
};

export const getDetailLicensesCustomerAction = (
  dataRequest,
  loadFilters,
  enqueueSnackbar,
) => async (dispatch) => {
  try {
    dispatch({ type: LICENSE_LOADING, payload: true });
    const config = defaultHeaders();

    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/license/getDetailsLicenseCustomer`, dataRequest, config);
    if (response.status === 200) {
      const { records } = response.data.result;
      dispatch({ type: GET_DETAIL_LICENSES_CUSTOMER, payload: response.data.result.records });

      if (records.length > 0 && loadFilters) {
        records.map((item) => {
          const customer = item.customerInfo;
          item.serviceLicense.map((service) => {
            dispatch(setFiltersLicenseAction('Load', service, customer, null));
          });
        });
      }

      dispatch({ type: LICENSE_LOADING, payload: false });
    }
  } catch (error) {
    const { response } = error;
    dispatch({ type: LICENSE_LOADING, payload: false });
    enqueueSnackbar(response.status === 404
      ? 'No se encontraron licencias para este cliente en el filtro seleccionado'
      : 'La solicitud no ha podido ser procesada', {
      variant: response.status === 404
        ? 'warning'
        : 'error',
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
    });
  }
};

export const clearLicensesCustomerAction = () => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_LICENSES_CUSTOMER, payload: [] });
    dispatch({ type: SET_CHIPS_FILTERS_LICENSES, payload: [] });
  } catch (error) {
    console.error(error);
  }
};

export const addNewLicenseCustomerAction = (
  dataRequest,
  enqueueSnackbar,
) => async (dispatch) => {
  try {
    dispatch({ type: LICENSE_LOADING, payload: true });
    const config = defaultHeaders();

    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/purchaseOrderLicense/AddNewCustomerLicense`, dataRequest, config);

    if (response.status === 200) {
      const { result } = response.data;
      dispatch({ type: ADD_LICENSE_CUSTOMER, payload: result.records });
      dispatch(
        setMessageAlertAction({
          category: 'createNewLicense',
          typeMsg: 'Success',
          tittleMsg: '¡Perfecto!',
          img: AddedLicenseSuccessfullyIcon,
          message: '¡Licencia añadida con éxito!',
          isOnlyMessage: true,
          autoHideAlert: true,
          showClose: false,
          showCloseAlert: false,
          showButtonCancel: true,
          popupStyle: { padding: '10%' },
          contentStyle: { display: 'grid', justifyItems: 'center' },
          styleMessage: { color: '#E45501', fontSize: 20 },
        }),
      );
      dispatch({ type: LICENSE_LOADING, payload: false });
    }
  } catch (error) {
    dispatch({ type: LICENSE_LOADING, payload: false });
    if (error.response) {
      if (error.response.status === 422) {
        enqueueSnackbar(error.response.data.result.error.errorDetail, {
          variant: 'warning',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        });
      } else {
        enqueueSnackbar('Se ha presentado un error al añadir la licencia al cliente', {
          variant: 'error',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        });
      }
    }
  }
};

export const saveCustomerAction = (
  formData,
  appName,
  history,
  geoCodeService,
  ImagePopup,
) => async (dispatch) => {
  try {
    dispatch({ type: LICENSE_LOADING, payload: true });
    const customer = {
      personType: formData.personTypeService,
      documentTypeId: formData.documentTypeIdService,
      documentNumber: formData.documentNumberService,
      legalName: formData.personTypeService === 'J' ? formData.legalNameService : null,
      firstName: formData.firstNameService,
      lastName: formData.lastNameService,
      cellphoneNumber: formData.cellphoneNumberService,
      email: formData.emailService,
      departmentId: formData.departmentIdService.value
        ? formData.departmentIdService.value
        : formData.departmentIdService,
      cityId: formData.cityIdService.id
        ? formData.cityIdService.id
        : formData.cityIdService,
      fulladdress: formData.fulladdressService.description,
      legalDocumentTypeId: formData.legalDocumentTypeIdService,
      legalDocumentNumber: formData.legalDocumentNumberService,
      legalFirstName: formData.legalFirstNameService,
      legalLastName: formData.legalLastNameService,
      dv: formData.dvService,
      addressAdditionalInformation: formData.additionalInfoService,
      addressLatGeocode: geoCodeService ? geoCodeService.lat : null,
      addressLngGeocode: geoCodeService ? geoCodeService.lng : null,
      contractStartDate: formData.contractStartTime ? formData.contractStartTime.format() : null,
      contractEndDate: formData.contractEndTime ? formData.contractEndTime.format() : null,
      linkToApp: formData.linkToApp,
    };

    const config = defaultHeaders();
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/Customer/SetCustomer`,
      customer, config,
    );

    const responseOrder = response.data;

    if (response.status === 200) {
      dispatch({ type: LICENSE_LOADING, payload: false });
      dispatch(
        setMessageAlertAction({
          category: 'license',
          typeMsg: 'Success',
          tittleMsg: '¡Perfecto!',
          img: ImagePopup,
          message: responseOrder.statusMessage,
          isOnlyMessage: true,
          autoHideAlert: true,
          showClose: false,
          showCloseAlert: false,
          showButtonCancel: true,
          popupStyle: { padding: '10%' },
          contentStyle: { display: 'grid', justifyItems: 'center' },
          styleMessage: { color: '#E45501', fontSize: 20 },
        }),
      );
    }
  } catch (error) {
    console.error(`Error al guardar el cliente: ${error.message}`);
    if (error.response) {
      if (error.response.status === 422) {
        dispatch(
          setMessageAlertAction({
            category: 'license',
            typeMsg: 'Error',
            tittleMsg: 'Error',
            message: '¡La empresa NO fue guardada!',
          }),
        );
      } else {
        dispatch(
          setMessageAlertAction({
            category: 'license',
            typeMsg: 'Error',
            tittleMsg: 'Error',
            message: '¡Error del servidor!',
            isOnlyMessage: true,
          }),
        );
      }
    }
  }
};

export const GetLicenseInformationRangesAction = (purchaseOrderLicenseId) => async (dispatch) => {
  try {
    const config = defaultHeaders();
    Object.assign(config.headers, {
      purchaseOrderLicenseId,
    });
    const response = await axios.get(`${API_LICENCIAMIENTO}/license/api/license/GetLicenseInformation`, config);
    if (response.status === 200) {
      dispatch({
        type: GET_LICENSE_INFORMATION,
        payload: response.data.result.records,
      });
    }
  } catch (error) {
    console.error(error);
    const { response } = error;
    if (response.status === 404) {
      dispatch({
        type: GET_LICENSE_INFORMATION,
        payload: response.data,
      });
    }
  }
};

export const SetLicenseTransactionRangeAction = (PurchaseOrderLicenseId, licenseTransactionRange, enqueueSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: LICENSE_LOADING, payload: true });

    const saveRanges = {
      PurchaseOrderLicenseId,
      licenseTransactionRange,
    };

    const config = defaultHeaders();
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/license/SetLicenseTransactionRange`,
      saveRanges, config,
    );

    if (response.status === 200) {
      dispatch(
        setMessageAlertAction({
          category: 'updateLicense',
          typeMsg: 'Success',
          tittleMsg: '¡Perfecto!',
          img: AddedLicenseSuccessfullyIcon,
          message: '¡Licencia actualizada con éxito!',
          isOnlyMessage: true,
          autoHideAlert: true,
          showClose: false,
          showCloseAlert: false,
          showButtonCancel: true,
          popupStyle: { padding: '10%' },
          contentStyle: { display: 'grid', justifyItems: 'center' },
          styleMessage: { color: '#E45501', fontSize: 20 },
        }),
      );
      dispatch({ type: LICENSE_LOADING, payload: false });
    }
  } catch (error) {
    const { response } = error;
    console.log('error', response);
    dispatch({ type: LICENSE_LOADING, payload: false });
    enqueueSnackbar(response.status === 422
      ? 'No se pudo actualizar la licencia al cliente.'
      : 'Se ha presentado un error al actualizar la licencia al cliente', {
      variant: response.status === 422
        ? 'warning'
        : 'error',
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
    });
  }
};

const dispatchUsers = (userType, formattedUsers, dispatch) => {
  switch (userType) {
    case 'MANAGERS':
      dispatch({
        type: GET_MANAGERS,
        payload: formattedUsers,
      });
      break;
    case 'OFFICERS':
      dispatch({
        type: GET_RISK_OFFICERS,
        payload: formattedUsers,
      });
      break;
    default:
      break;
  }
};

export const getManagersAction = (role, userType) => async (dispatch) => {
  try {
    const config = defaultHeaders();
    Object.assign(config.headers, {
      role,
    });
    const response = await axios.get(`${API_SEGURIDAD}/api/user/get-users-by-role`, config);
    if (response.status === 200) {
      const { users } = response.data.result.recordsData[0];
      const formattedUsers = users.map((user) => ({
        value: user.sequence,
        label: `${user.names} ${user.surnames}`,
      }));
      dispatchUsers(userType, formattedUsers, dispatch);
    }
  } catch (error) {
    console.error(error);
    dispatchUsers(userType, [], dispatch);
  }
};

/**
 * Get a descrition when param is a object
 * @param {*} objectOrText
 * @returns address
 */
const getAddress = (objectOrText) => {
  if (typeof objectOrText === 'object' && objectOrText !== null && objectOrText !== undefined) {
    return objectOrText.description;
  }
  return objectOrText;
};

export const saveContractAction = (
  formData,
  appName,
  isRequiredSupervision,
  countryCode,
) => async (dispatch) => {
  try {
    dispatch({ type: LICENSE_LOADING, payload: true });
    const contract = {
      contractNumber: formData.contractService,
      contractStartDate: formData.startDate.startOf('day').format(),
      contractEndDate: formData.endDate.endOf('day').format(),
      commercialManagerId: formData.gestorService,
      paymentConditionId: formData.paymentService,
      riskOfficerId: formData.riskOfficer,
    };
    const customer = {
      personType: formData.personTypeService,
      documentTypeId: formData.documentTypeIdService,
      documentNumber: formData.documentNumberService,
      legalName: formData.personTypeService === 'J' ? formData.legalNameService : null,
      firstName: formData.personTypeService === 'N' ? formData.firstNameService : null,
      lastName: formData.personTypeService === 'N' ? formData.lastNameService : null,
      dv: formData.dvService,
      fulladdress: getAddress(formData.fulladdressService),
      cityId: formData.cityIdService.id
        ? formData.cityIdService.id
        : formData.cityIdService,
      cellphoneNumber: formData.cellphoneNumberService,
      email: formData.emailService,
      legalDocumentTypeId: formData.legalDocumentTypeIdService,
      legalDocumentNumber: formData.legalDocumentNumberService,
      legalFirstName: formData.legalFirstNameService,
      legalLastName: formData.legalLastNameService,
      CountryCodeIso3: countryCode,
    };
    const supervisor = {
      documentTypeId: formData.documentTypeIdSupervisor,
      documentNumber: formData.documentNumberSupervisor,
      firstName: formData.namesSupervisor,
      lastName: formData.lastNameSupervisor,
      fulladdress: getAddress(formData.CustomFulladdressService),
      cityId: formData.CustomCityIdService.id
        ? formData.CustomCityIdService.id
        : formData.CustomCityIdService,
      phoneNumber: formData.cellphoneNumberSupervisor,
      email: formData.emailSupervisor,
      jobTitle: formData.supervisorPosition,
      CountryCodeIso3: countryCode,
    };
    const servicesToAddContract = {
      servicesToAdd: formData.servicesToAdd,
      serviceName: appName,
      requiresSupervision: isRequiredSupervision,
    };

    const registerContractRequest = {
      contract,
      customer,
      supervisor,
      servicesToAddContract,
    };

    const config = defaultHeaders();
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/contract/create`,
      registerContractRequest, config,
    );
    if (response.status === 200) {
      dispatch({ type: LICENSE_LOADING, payload: false });
      dispatch(
        setMessageAlertAction({
          message: '¡Convenio guardado!',
          isSaved: true,
        }),
      );
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: LICENSE_LOADING, payload: false });
    dispatch(
      setMessageAlertAction({
        message: '¡Algo salió mal!',
        mensajeModal: 'Lo sentimos, el convenio no pudo ser guardado.',
        isSaved: false,
      }),
    );
  }
};

export const getAppParametersContractsAction = (appName, parameterType, validityType, startDateParameter, parameterTypeReassignmentQuota, parameterTypeValidityAmount, parameterMaxContractValidity, riskOfficeRole) => async (dispatch) => {
  try {
    const config = defaultHeaders();
    const parameters = {
      DocumentTypeParameters: parameterType,
      ValidityType: validityType,
      StartDateParameter: startDateParameter,
      RiskOfficerRole: riskOfficeRole,
    };
    Object.assign(config.headers, {
      appName,
      parameters: JSON.stringify(parameters),
      parameterTypeReassignmentQuota,
      parameterTypeValidityAmount,
      parameterMaxContractValidity,
    });
    const response = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/get-app-parameters-contracts`, config);
    if (response.status === 200) {
      const {
        listPaymentType = [],
        listDocumentType = [],
        listValidityType = [],
        listDeviceType = [],
        listCredentialDelivery = [],
        parameterMaxReassignmentQuota = 5,
        startDateParams = {},
        parameterMaxValidityAmount = [],
        showLegalRepresentativeContract = false,
        parameterMaxValidityContract = 2,
        alertPeriodicityParams,
        riskOfficerRole,
        listCredentialParams,
        opportunityInputValidation,
      } = response.data.result.records;
      const transformedListPaymentType = (listPaymentType ?? []).map((payment) => ({
        value: payment.paymentTypeId,
        label: payment.paymentTypeName,
      }));
      const transformedListValidityType = (listValidityType ?? []).map((validity) => ({
        value: validity.id,
        label: validity.nameValidity,
      }));
      const transformedListDeviceType = (listDeviceType ?? []).map((device) => ({
        value: device.id,
        label: device.nameDevice,
        codeDevice: device.codeDevice,
      }));
      const transformedListCredentialDelivery = (listCredentialDelivery ?? []).map((delivery) => ({
        value: delivery.id,
        label: delivery.nameDelivery,
      }));
      const transformedListMaxValidityAmount = (parameterMaxValidityAmount ?? []).map((validity) => ({
        value: validity.id,
        amount: validity.amount,
      }));
      const transformedStartDate = {
        isBeyondOneMonth: startDateParams?.isBeyondOneMonth ?? false,
        dateUnit: startDateParams?.dateUnit ?? 'days',
        quantity: startDateParams?.quantity ?? 0,
      };
      const mapToOptions = (arr) => arr.map((el) => ({ value: el.key, label: el.value }));

      const deliveryFrecuency = mapToOptions(alertPeriodicityParams?.deliveryFrecuency);
      const alertDeliveryTime = mapToOptions(alertPeriodicityParams?.alertDeliveryTime);
      const alertDeliveryDays = mapToOptions(alertPeriodicityParams?.alertDeliveryDays);

      dispatch({
        type: GET_APP_PARAMETERS_CONTRACTS,
        listPaymentTypeContracts: transformedListPaymentType.length > 0 ? transformedListPaymentType : [],
        listDocumentTypeContracts: (listDocumentType ?? []).length > 0 ? listDocumentType : [],
        listValidityTypeContracts: transformedListValidityType.length > 0 ? transformedListValidityType : [],
        listDeviceTypeContracts: transformedListDeviceType.length > 0 ? transformedListDeviceType : [],
        listCredentialDeliveryContracts: transformedListCredentialDelivery.length > 0 ? transformedListCredentialDelivery : [],
        parameterMaxReassignmentQuota,
        showLegalRepresentativeContract,
        startDateParams: transformedStartDate,
        transformedListMaxValidityAmountContracts: transformedListMaxValidityAmount.length > 0 ? transformedListMaxValidityAmount : [],
        parameterMaxValidityContract,
        riskOfficerRole,
        listCredentialParams,
        opportunityInputValidation,
        alertPeriodicityParams: {
          consumptionPercentageAlert: alertPeriodicityParams?.consumptionPercentageAlert ?? 90,
          alertDeliveryDays: alertDeliveryDays ?? [],
          deliveryFrecuency: deliveryFrecuency ?? [],
          alertDeliveryTime: alertDeliveryTime ?? [],
        },
      });
    }
  } catch (error) {
    console.error(error);
    dispatch({
      type: GET_APP_PARAMETERS_CONTRACTS,
      listPaymentTypeContracts: [],
      listDocumentTypeContracts: [],
      listValidityTypeContracts: [],
      listDeviceTypeContracts: [],
      listCredentialDeliveryContracts: [],
      parameterMaxReassignmentQuota: 5,
      showLegalRepresentativeContract: false,
      startDateParams: {
        isBeyondOneMonth: false,
        dateUnit: 'days',
        quantity: 0,
      },
      transformedListMaxValidityAmountContracts: [],
      parameterMaxValidityContract: 2,
      alertPeriodicityParams: {},
    });
  }
};

export const getContractDataAction = (contractNumber, serviceName) => async (dispatch) => {
  try {
    const config = defaultHeaders();

    const contractNumberRequest = {
      contractNumber,
      serviceName,
    };

    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/contract/get-contracts`, contractNumberRequest, config);
    if (response.status === 200) {
      dispatch({
        type: GET_CONTRACT_DATA,
        payload: {
          contractNumber: response.data.result.contractNumber,
          existContract: true,
        },
      });
    } else {
      dispatch({
        type: GET_CONTRACT_DATA,
        payload: {
          contractNumber: '',
          existContract: false,
        },
      });
    }
  } catch (error) {
    console.error(error);
    dispatch({
      type: GET_CONTRACT_DATA,
      payload: {
        contractNumber: '',
        existContract: false,
      },
    });
  }
};

export const getContractCustomerInfoAction = (personType, documentType, documentNumber, countryCode = 'COL', isMarket = false) => async (dispatch) => {
  try {
    dispatch({ type: LOADING_CONTRACT_CUSTOMER_INFO, payload: true });
    const config = isMarket ? defaultHeadersMarket() : defaultHeaders();

    Object.assign(config.headers, {
      personType,
      documentType,
      documentNumber,
      countryCode,
    });
    const response = await axios.get(`${API_LICENCIAMIENTO}/license/api/contract/get-customer-info`, config);
    const { result } = response.data;
    dispatch({
      type: GET_CONTRACT_CUSTOMER_INFO,
      payload: result,
    });
    dispatch({ type: LOADING_CONTRACT_CUSTOMER_INFO, payload: false });
    return result;
  } catch (error) {
    dispatch({
      type: GET_CONTRACT_CUSTOMER_INFO,
      payload: {},
    });
    dispatch({ type: LOADING_CONTRACT_CUSTOMER_INFO, payload: false });
    return null;
  }
};

export const getContractSupervisiorInfoAction = (documentType, documentNumber, countryCode = 'COL', isMarket = false) => async (dispatch) => {
  try {
    dispatch({ type: LOADING_CONTRACT_SUPERVISOR_INFO, payload: true });
    const config = isMarket ? defaultHeadersMarket() : defaultHeaders();

    Object.assign(config.headers, {
      documentType,
      documentNumber,
      countryCode,
    });
    const response = await axios.get(`${API_LICENCIAMIENTO}/license/api/contract/get-supervisor-info`, config);
    const { result } = response.data;
    dispatch({
      type: GET_CONTRACT_SUPERVISOR_INFO,
      payload: result,
    });
    dispatch({ type: LOADING_CONTRACT_SUPERVISOR_INFO, payload: false });
    return result;
  } catch (error) {
    dispatch({
      type: GET_CONTRACT_SUPERVISOR_INFO,
      payload: {},
    });
    dispatch({ type: LOADING_CONTRACT_SUPERVISOR_INFO, payload: false });
    return null;
  }
};

export const getServicesDataDashboardAction = (customer) => async (dispatch, getState) => {
  try {
    const customerInfoRequest = {
      documentType: '',
      documentNumber: '',
    };
    const {
      auth: { userInfo },
    } = getState();

    if (customer?.documentType != null && customer?.documentNumber != null) {
      customerInfoRequest.documentType = customer.documentType;
      customerInfoRequest.documentNumber = customer.documentNumber;
    } else {
      customerInfoRequest.documentType = userInfo.customer_type;
      customerInfoRequest.documentNumber = userInfo.customer_value;
    }

    dispatch({ type: LICENSE_LOADING, payload: true });
    const config = defaultHeaders();

    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/dashboard/dashboard-customer`, customerInfoRequest, config);

    if (response.status === 200) {
      dispatch({
        type: GET_SERVICES_DATA_DASHBOARD,
        payload: response.data.result,
      });
      dispatch({ type: LICENSE_LOADING, payload: false });
    } else {
      dispatch({
        type: GET_SERVICES_DATA_DASHBOARD,
        payload: [],
      });
      dispatch({ type: LICENSE_LOADING, payload: false });
    }
  } catch (error) {
    console.error(error);
    dispatch({
      type: GET_SERVICES_DATA_DASHBOARD,
      payload: [],
    });
    dispatch({ type: LICENSE_LOADING, payload: false });
  }
};

export const clearServicesDataDashboardAction = () => ({
  type: CLEAR_SERVICES_DATA_DASHBOARD,
});

const createContractsObject = (data, requiresSupervision) => {
  const dataResult = data?.result;
  if (dataResult) {
    return {
      contractPackageId: `${dataResult.serviceName}-${dataResult.packageCode}-${requiresSupervision}`,
      quantityAccumulated: dataResult.quantityAccumulated,
      balanceAccumulated: dataResult.balanceAccumulated,
      usedAccumulated: dataResult.usedAccumulated,
      contractServiceDetail: dataResult.contractServiceDetail,
      isUnlimited: dataResult.isUnlimited,
      serviceFeatureCode: dataResult.serviceFeatureCode,
    };
  }
  return {};
};

/**
 * Get detail contract of a specific product.
 * @param {*} ServiceName
 * @param {*} PackageCode
 * @returns a object with all details of contracts.
 */
export const getDetailContractsAction = (ServiceName, PackageCode, RequiresSupervision, customer) => async (dispatch, getState) => {
  const {
    auth: { userInfo },
  } = getState();

  let DocumentType = userInfo?.customer_type;
  let DocumentNumber = userInfo?.customer_value;
  if (customer != null) {
    DocumentType = customer.documentType;
    DocumentNumber = customer.documentNumber;
  }

  if (DocumentType && DocumentNumber && ServiceName && PackageCode) {
    try {
      const config = defaultHeaders();
      const contractNumberRequest = {
        DocumentType,
        DocumentNumber,
        ServiceName,
        PackageCode,
        IsSupervised: RequiresSupervision,
      };
      const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/dashboard/contracted-service-details`, contractNumberRequest, config);
      if (response.status === 200) {
        const contracts = createContractsObject(response.data, RequiresSupervision);
        dispatch({
          type: GET_DETAIL_CONTRACTS,
          payload: (() => {
            const prevState = getState().license?.detailContracts || [];
            const index = prevState.findIndex((item) => item.contractPackageId === contracts.contractPackageId);
            if (index !== -1) {
              const updatedData = [...prevState];
              updatedData[index] = contracts;
              return updatedData;
            }
            return [...prevState, contracts];
          })(),
        });
      }
    } catch (error) {
      console.warn('Error obtaining detail of contracts ', error);
    }
  }
  return null;
};

export const getClearHistoryConsumptionDataDashboardAction = () => async (dispatch) => {
  dispatch({
    type: GET_HISTORY_CONSUMPTION_DASHBOARD,
    payload: {},
  });
};

export const getHistoryConsumptionDataDashboardAction = (data, history, enqueueSnackbar, skip, take, totalDashboardDaysRange = 1) => async (dispatch, getState) => {
  try {
    const historyInfoRequest = {
      documentType: '',
      documentNumber: '',
      serviceName: '',
      serviceFeatureCode: '',
      startDate: '',
      endDate: '',
      isSupervised: '',
    };

    sessionStorage.setItem('totalDashboardDaysRange', totalDashboardDaysRange);

    const { license: { getHistoryConsumptionDashboard } } = getState();

    if (data) {
      historyInfoRequest.documentType = data?.documentType;
      historyInfoRequest.documentNumber = data?.documentNumber;
      historyInfoRequest.serviceName = data?.serviceName;
      historyInfoRequest.serviceFeatureCode = data?.serviceFeatureCode;
      historyInfoRequest.startDate = data?.startDate;
      historyInfoRequest.endDate = data?.endDate;
      historyInfoRequest.isSupervised = data?.isSupervised;
    }

    dispatch({ type: GET_REQUEST_DASHBOARD, payload: historyInfoRequest });

    dispatch({ type: LICENSE_LOADING, payload: true });
    const config = defaultHeaders();

    Object.assign(config.headers, {
      skip,
      take,
    });

    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/dashboard/consumption-history`, historyInfoRequest, config);
    if (response.status === 200) {
      const newData = response.data.result;

      const newHistory = newData.consumptionDetailHistory || [];
      const existingData = getHistoryConsumptionDashboard || {};
      const existingHistory = existingData.consumptionDetailHistory || [];

      const updatedHistory = [...existingHistory, ...newHistory];
      const updatedPayload = {
        ...newData,
        consumptionDetailHistory: updatedHistory,
      };

      dispatch({
        type: GET_HISTORY_CONSUMPTION_DASHBOARD,
        payload: updatedPayload,
      });
    } else {
      dispatch({
        type: GET_HISTORY_CONSUMPTION_DASHBOARD,
        payload: {},
      });
    }
    if (history) history.push('/admin/dashboard/movements');
    dispatch({ type: LICENSE_LOADING, payload: false });
  } catch (error) {
    if (error.response.status === 422) {
      dispatch(
        setMessageAlertAction({
          message: '¡Algo salió mal!',
          mensajeModal: error?.response?.data?.statusDetails?.[0]?.description,
          isSaved: false,
        }),
      );
    }
    dispatch({
      type: GET_HISTORY_CONSUMPTION_DASHBOARD,
      payload: error?.response?.data?.result || {},
    });
    if (history) history.push('/admin/dashboard/movements');
    dispatch({ type: LICENSE_LOADING, payload: false });
  }
};

export const getContractDetailsAction = (contractNumber, serviceFeatureId, history) => async (dispatch) => {
  try {
    const contractDetails = {
      contractNumber,
      serviceFeatureId,
    };

    const config = defaultHeaders();
    dispatch({ type: LICENSE_LOADING, payload: true });
    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/dashboard/contract-details`, contractDetails, config);
    if (response.status === 200) {
      dispatch({
        type: GET_CONTRACT_DETAILS,
        payload: response.data.result,
      });
      dispatch({ type: LICENSE_LOADING, payload: false });
    } else {
      dispatch({
        type: GET_CONTRACT_DETAILS,
        payload: [],
      });
      dispatch({ type: LICENSE_LOADING, payload: false });
    }
    if (history) history.push('/admin/dashboard/contractInfo');
  } catch (error) {
    console.error(error);
    dispatch({
      type: GET_CONTRACT_DETAILS,
      payload: [],
    });
    if (history) history.push('/admin/dashboard/contractInfo');
    dispatch({ type: LICENSE_LOADING, payload: false });
  }
};

export const getAgreementListAction = (contractNumber = '', serviceName = '', skip = 0, take = 0) => async (dispatch, getState) => {
  try {
    const config = defaultHeaders();
    const { general: { tenant } } = getState();
    if (tenant) {
      Object.assign(config.headers, { tenant });
    }
    const infoRequest = {
      ContractNumber: contractNumber,
      ServiceName: serviceName,
      skip,
      take,
    };
    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/contract/list`, infoRequest, config);
    const { result } = response?.data;
    dispatch({
      type: GET_AGREEMENTS_LIST,
      payload: result || [],
    });
    return result;
  } catch (error) {
    dispatch({
      type: GET_AGREEMENTS_LIST,
      payload: [],
    });
    return null;
  }
};

const getArrayOfDays = (savedUserAlert) => {
  const days = [];
  if (savedUserAlert) {
    if (savedUserAlert.monday) days.push('Lunes');
    if (savedUserAlert.tuesday) days.push('Martes');
    if (savedUserAlert.wednesday) days.push('Miércoles');
    if (savedUserAlert.thursday) days.push('Jueves');
    if (savedUserAlert.friday) days.push('Viernes');
    if (savedUserAlert.saturday) days.push('Sábado');
    if (savedUserAlert.sunday) days.push('Domingo');
  }
  return days;
};

export const getInformationAgreementAction = (id, contractNumber = '') => async (dispatch) => {
  try {
    dispatch({ type: LICENSE_LOADING, payload: true });
    const config = defaultHeaders();
    const contractsRequest = {
      id,
      contractNumber,
    };
    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/contract/search`, contractsRequest, config);
    if (response.data.statusCode === 200) {
      const contract = {
        contractService: response.data?.result?.contractNumber,
        startDate: response.data?.result?.contractStartDate,
        endDate: response.data?.result?.contractEndDate,
        gestorService: response.data?.result?.commercialManagerId,
        paymentService: response.data?.result?.paymentConditionId,
        serviceName: response.data?.result?.serviceId,
        riskOfficerId: response.data?.result?.riskOfficerId,
      };

      const customer = {
        personTypeService: response.data?.result?.customer?.personType || null,
        documentTypeIdService: response.data?.result?.customer?.documentTypeId || null,
        documentNumberService: response.data?.result?.customer?.documentNumber || null,
        legalNameService: response.data?.result?.customer?.legalName || null,
        firstNameService: response.data?.result?.customer?.firstName || null,
        lastNameService: response.data?.result?.customer?.lastName || null,
        dvService: response.data?.result?.customer?.dv || null,
        fulladdressService: response.data?.result?.customer?.fullAddress || null,
        cityIdService: response.data?.result?.customer?.cityId || null,
        departmentIdService: response.data?.result?.customer?.stateId || null,
        cellphoneNumberService: response.data?.result?.customer?.cellphoneNumber || null,
        emailService: response.data?.result?.customer?.email || null,
        legalDocumentTypeIdService: response.data?.result?.customer?.legalDocumentTypeId || null,
        legalDocumentNumberService: response.data?.result?.customer?.legalDocumentNumber || null,
        legalFirstNameService: response.data?.result?.customer?.legalFirstName || null,
        legalLastNameService: response.data?.result?.customer?.legalLastName || null,
      };

      const userNotifications = response.data?.result?.contractNotification;

      const userAlertOptions = {
        consumptionPercentageAlert: userNotifications.consumptionPercentageAlert,
        deliveryTime: userNotifications.notificationDeliveryTime,
        deliveryFrecuency: userNotifications.deliveryFrequency,
        alertDeliveryDays: getArrayOfDays(userNotifications),
      };

      const supervisor = {
        documentTypeIdSupervisor: response.data?.result?.supervisor?.documentTypeId || null,
        documentNumberSupervisor: response.data?.result?.supervisor?.documentNumber || null,
        namesSupervisor: response.data?.result?.supervisor?.firstName || null,
        lastNameSupervisor: response.data?.result?.supervisor?.lastName || null,
        CustomFulladdressService: response.data?.result?.supervisor?.fullAddress || null,
        CustomCityIdService: response.data?.result?.supervisor?.cityId || null,
        CustomDepartmentIdService: response.data?.result?.supervisor?.stateId || null,
        cellphoneNumberSupervisor: response.data?.result?.supervisor?.phoneNumber || '',
        emailSupervisor: response.data?.result?.supervisor?.email || null,
        supervisorPosition: response.data?.result?.supervisor?.jobTitle || '',
      };

      const registerContractRequest = {
        contract,
        customer,
        supervisor,
        contractedServices: response.data?.result?.contractedServices ?? [],
        userAlertOptions,
      };
      dispatch({
        type: GET_INFORMATION_AGREEMENT,
        payload: registerContractRequest,
      });
    }
  } catch (error) {
    console.error(error);
    dispatch({
      type: GET_INFORMATION_AGREEMENT,
      payload: {},
    });
    dispatch({ type: LICENSE_LOADING, payload: false });
  }
};

const getDaysInEnglish = (listOfDay) => ({
  Monday: listOfDay.includes('Lunes') ?? false,
  Tuesday: listOfDay.includes('Martes') ?? false,
  Wednesday: listOfDay.includes('Miércoles') ?? false,
  Thursday: listOfDay.includes('Jueves') ?? false,
  Friday: listOfDay.includes('Viernes') ?? false,
  Saturday: listOfDay.includes('Sábado') ?? false,
  Sunday: listOfDay.includes('Domingo') ?? false,
});

const getNotificationRequest = (userOptionsAlerts) => {
  if (userOptionsAlerts) {
    return {
      ConsumptionPercentageAlert: userOptionsAlerts.consumptionPercentageAlert,
      NotificationDeliveryTime: userOptionsAlerts.deliveryTime,
      DeliveryFrequency: userOptionsAlerts.deliveryFrecuency,
      ...getDaysInEnglish(userOptionsAlerts.deliveryFrecuency === 'D' ? [] : userOptionsAlerts.alertDeliveryDays),
    };
  }
  return {};
};

export const modifyInformationAgreementAction = (activeStep, data, ticket, Observations, contractId, serviceName, isRequiredSupervision, componentNameSelected, servicesToAdd, listDeviceTypeContracts, countryCode) => async (dispatch) => {
  try {
    dispatch({ type: LICENSE_LOADING_UPDATE_AGREEMENT, payload: true });
    let modifyContractRequest = {};
    const getGeneralInfo = (Step) => ({
      ContractId: contractId,
      TicketId: ticket,
      Observations,
      Step,
      ServiceName: serviceName,
      RequiresSupervision: isRequiredSupervision,
    });
    if (activeStep === 0) {
      modifyContractRequest = {
        ...getGeneralInfo('UPDATE_CONTRACT'),
        Contract: {
          ContractNumber: data?.contractService,
          ContractStartDate: data?.startDate.startOf('day').format(),
          ContractEndDate: data?.endDate.endOf('day').format(),
          CommercialManagerId: data?.gestorService,
          PaymentConditionId: data?.paymentService,
          RiskOfficerId: data?.riskOfficer,
        },
        Customer: null,
        Supervisor: null,
        ContractedServices: null,
      };
    }
    if (activeStep === 1) {
      modifyContractRequest = {
        ...getGeneralInfo('UPDATE_CUSTOMER'),
        Contract: null,
        Customer: {
          personType: data?.personTypeService,
          documentTypeId: data?.documentTypeIdService,
          documentNumber: data?.documentNumberService,
          legalName: data?.personTypeService === 'J' ? data?.legalNameService : null,
          firstName: data?.personTypeService === 'N' ? data?.firstNameService : null,
          lastName: data?.personTypeService === 'N' ? data?.lastNameService : null,
          dv: data?.dvService,
          fulladdress: getAddress(data?.fulladdressService),
          cityId: data?.cityIdService?.id
            ? data?.cityIdService?.id
            : data?.cityIdService,
          cellphoneNumber: data?.cellphoneNumberService,
          email: data?.emailService,
          legalDocumentTypeId: data?.legalDocumentTypeIdService,
          legalDocumentNumber: data?.legalDocumentNumberService,
          legalFirstName: data?.legalFirstNameService,
          legalLastName: data?.legalLastNameService,
          CountryCodeIso3: countryCode,
        },
        Supervisor: null,
        ContractedServices: null,
      };
    }
    if (activeStep === 2) {
      modifyContractRequest = {
        ...getGeneralInfo('UPDATE_SUPERVISOR'),
        Contract: null,
        Customer: null,
        Supervisor: {
          documentTypeId: data?.documentTypeIdSupervisor,
          documentNumber: data?.documentNumberSupervisor,
          firstName: data?.namesSupervisor,
          lastName: data?.lastNameSupervisor,
          fulladdress: getAddress(data?.CustomFulladdressService),
          cityId: data?.CustomCityIdService.id
            ? data?.CustomCityIdService.id
            : data?.CustomCityIdService,
          phoneNumber: data?.cellphoneNumberSupervisor,
          email: data?.emailSupervisor,
          jobTitle: data?.supervisorPosition,
          CountryCodeIso3: countryCode,
        },
        ContractedServices: null,
      };
    }
    if (activeStep === 3) {
      let transformedServices;
      const filteredServices = servicesToAdd.filter(
        (item) => item.isUpdate === true || item.licenseId == null,
      );
      if (componentNameSelected && componentNameSelected === 'isComponentServices') {
        transformedServices = filteredServices.map((item) => ({
          licenseDetailId: item?.licenseId ?? null,
          packageCode: item.productService,
          quantityToAdd: item.quantityToAddService ? parseInt(item.quantityToAddService, 10) : 0,
          identifierCode: `${item.productService}_${item.validityAmount}${item.validityService}`,
          validityType: item.validityService,
          validityPeriod: parseInt(item.validityAmount, 10),
          IsUnlimited: item.isSwitchEnabled ?? item.isUnlimited,
        }));
      } else {
        transformedServices = filteredServices.map((item) => ({
          licenseDetailId: item?.licenseId ?? null,
          packageCode: item.productService,
          quantityToAdd: parseInt(item.quantityToAddService, 10),
          identifierCode: `${item.productService}_${listDeviceTypeContracts.find((validity) => validity.value === item.deviceType)?.codeDevice}_${item.validityAmount}${item.validityService}`,
          validityType: item.validityService,
          validityPeriod: parseInt(item.validityAmount, 10),
          reassignmentQuota: parseInt(item.reassignmentQuota, 10),
          deviceType: item.deviceType,
          credentialsDeliveryType: item.credentialsDeliveryType,
        }));
      }
      modifyContractRequest = {
        ...getGeneralInfo('UPDATE_CONTRACTEDSERVICES'),
        Contract: null,
        Customer: null,
        Supervisor: null,
        ContractedServices: transformedServices,
      };
    }
    const notfication = getNotificationRequest(data.userAlertOptions);
    if (activeStep === 4) {
      modifyContractRequest = {
        ...getGeneralInfo('SET_CONTRACT_NOTIFICATION'),
        Contract: null,
        Customer: null,
        Supervisor: null,
        ContractedServices: null,
        ContractNotification: notfication,
      };
    }
    const config = defaultHeaders();
    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/contract/modify`, modifyContractRequest, config);
    if (response.data.statusCode === 200) {
      dispatch({
        type: MODIFY_INFORMATION_AGREEMENT,
        payload: response.data,
      });
      dispatch({ type: LICENSE_LOADING_UPDATE_AGREEMENT, payload: false });
    }
  } catch (error) {
    console.error(error.response);
    dispatch({
      type: MODIFY_INFORMATION_AGREEMENT,
      payload: error.response.data,
    });
    dispatch({ type: LICENSE_LOADING_UPDATE_AGREEMENT, payload: false });
  }
};

export const getLoadCartMarketPlaceAction = (transactionCode, tenant) => async (dispatch, getState) => {
  const { general: { getParametersMarket } } = getState();
  try {
    dispatch({ type: LOADING_MARKET_PLACE, payload: true });
    dispatch({ type: GET_CART_ERROR, payload: { hasError: false, url: null } });

    const config = defaultHeadersMarket();
    Object.assign(config.headers, { transactionCode });

    const response = await axios.get(`${API_LICENCIAMIENTO}/license/api/cart/load`, config);

    const { result } = response.data;
    dispatch({ type: SET_MARKET_CONTEXT, payload: result });

    const cartWithQuantities = {
      ...result,
      cartItems: result.cartItems.map((item) => ({
        ...item,
        quantity: item?.quantity ?? 1,
        identifierCode: `${item.packageCode}_${item.deviceTypeCode}_${item.validityPeriod}${item.validityTypeId}`,
      })),
    };
    dispatch({
      type: GET_CART_SUCCESS,
      payload: cartWithQuantities,
    });

    dispatch({ type: LOADING_MARKET_PLACE, payload: false });
  } catch (error) {
    const urlFromBack = error.response?.data?.result?.urlMarketPlace;
    let urlFromParams = null;
    if (Array.isArray(getParametersMarket) && getParametersMarket.length > 0) {
      const foundParam = getParametersMarket.find(
        (param) => param?.parameterCode === 'URL_Market_Tenant'
          && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
      );
      if (foundParam) {
        urlFromParams = foundParam?.parameterValue;
      }
    }
    const urlFromConfig = TENANT_LANDINGS[tenant];
    dispatch({
      type: GET_CART_SUCCESS,
      payload: {},
    });
    dispatch({
      type: GET_CART_ERROR,
      payload: { hasError: true, url: urlFromBack || urlFromParams || urlFromConfig },
    });

    const errorResult = error?.response?.data?.result;
    let countryFromParams = null;
    if (Array.isArray(getParametersMarket) && getParametersMarket.length > 0) {
      const foundParamCountry = getParametersMarket.find(
        (param) => param?.parameterCode === 'COUNTRY_DEFAULT'
          && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
      );
      if (foundParamCountry) {
        countryFromParams = foundParamCountry?.parameterValue;
      }
    }

    dispatch({ type: LOADING_MARKET_PLACE, payload: false });
    dispatch({
      type: SET_MARKET_CONTEXT,
      payload: {
        ...errorResult,
        countryCode: errorResult?.countryCode || countryFromParams,
      },
    });
  }
};

export const updateCartQuantityAction = (identifierCode, delta, maxQuantity = 100) => (dispatch) => {
  dispatch({
    type: UPDATE_LOCAL_QUANTITY,
    payload: { identifierCode, delta, maxQuantity },
  });
};

export const removeCartItemAction = (identifierCode) => (dispatch) => {
  dispatch({
    type: REMOVE_CART_ITEM,
    payload: identifierCode,
  });
};

export const getLicensesToAssignAction = (referenceUuid, tenant) => async (dispatch, getState) => {
  const { general: { getParametersMarket } } = getState();
  try {
    dispatch({ type: LOADING_LOAD_PRODUCTS_ASSIGNMENTS, payload: true });
    dispatch({ type: GET_CART_ERROR, payload: { hasError: false, url: null } });
    dispatch({ type: PRODUCT_WAS_ASSIGNED, payload: false });

    const config = defaultHeadersMarket();
    Object.assign(config.headers, { referenceUuid });

    const response = await axios.get(`${API_LICENCIAMIENTO}/license/api/license/load-products-assignments`, config);
    const { result } = response.data;
    dispatch({ type: SET_MARKET_CONTEXT, payload: result });

    const billingData = {
      personType: result.customerBilling?.personType,
      firstName: result.customerBilling?.firstName,
      lastName: result.customerBilling?.lastName,
      documentTypeId: result.customerBilling?.documentTypeId,
      documentNumber: result.customerBilling?.documentNumber,
      email: result.customerBilling?.email,
      cellphone: result.customerBilling?.cellphoneNumber,
      countryCallingCode: result.customerBilling?.countryCallingCode,
      countryCallingIso3: result.customerBilling?.countryCallingIso3,
      fullAddress: result.customerBilling?.fullAddress,
      cityId: result.customerBilling?.cityId,
    };

    const preparedLicenses = result.packagesToAssign.map((item) => ({
      id: item.purchaseOderLicenseId,
      title: item.packageName,
      status: 'Pendiente',
      assigned: null,
      quantity: item.quantity,
      billing: billingData,
      identifierCode: item.identifierCode,
      packageCode: item.packageCode,
      isDelegatedManagement: item.isDelegatedManagement,
      validityPeriod: item.validityPeriod,
      validityTypeId: item.validityTypeId,
      deviceCode: item.deviceCode,
    }));

    dispatch({
      type: GET_LICENSES_SUCCESS,
      payload: preparedLicenses,
    });

    dispatch({ type: LOADING_LOAD_PRODUCTS_ASSIGNMENTS, payload: false });
  } catch (error) {
    dispatch({ type: PRODUCT_WAS_ASSIGNED, payload: false });
    const isAssigned = error?.response?.data?.statusDetails?.[0]?.code;
    const urlFromBack = error.response?.data?.result?.urlMarketPlace;
    let urlFromParams = null;
    if (Array.isArray(getParametersMarket) && getParametersMarket.length > 0) {
      const foundParam = getParametersMarket.find(
        (param) => param?.parameterCode === 'URL_Market_Tenant'
          && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
      );
      if (foundParam) {
        urlFromParams = foundParam.parameterValue;
      }
    }
    const urlFromConfig = TENANT_LANDINGS[tenant];
    if (isAssigned && isAssigned === 'ER38') {
      dispatch({ type: PRODUCT_WAS_ASSIGNED, payload: true });
    } else {
      dispatch({
        type: GET_CART_ERROR,
        payload: { hasError: true, url: urlFromBack || urlFromParams || urlFromConfig },
      });
    }
    dispatch({
      type: GET_LICENSES_SUCCESS,
      payload: [],
    });

    dispatch({ type: LOADING_LOAD_PRODUCTS_ASSIGNMENTS, payload: false });
    const errorResult = error?.response?.data?.result;
    let countryFromParams = null;
    if (Array.isArray(getParametersMarket) && getParametersMarket.length > 0) {
      const foundParamCountry = getParametersMarket.find(
        (param) => param?.parameterCode === 'COUNTRY_DEFAULT'
          && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
      );
      if (foundParamCountry) {
        countryFromParams = foundParamCountry?.parameterValue;
      }
    }
    dispatch({
      type: SET_MARKET_CONTEXT,
      payload: {
        ...errorResult,
        countryCode: errorResult?.countryCode || countryFromParams,
      },
    });
  }
};

export const updateLicenseInReduxAction = (id, holderData) => (dispatch) => {
  dispatch({
    type: UPDATE_LICENSE_DATA,
    payload: { id, holderData },
  });
};

export const deleteLicenseAssignmentAction = (id) => (dispatch) => {
  dispatch({
    type: DELETE_LICENSE_ASSIGNMENT,
    payload: id,
  });
};

export const getCatalogAction = (countryCode) => async (dispatch) => {
  try {
    const config = defaultHeadersMarket();
    Object.assign(config.headers, {
      countryCode,
    });
    const response = await axios.get(
      `${API_LICENCIAMIENTO}/license/api/catalog/get`,
      config,
    );
    if (response.status === 200) {
      const rawCatalog = response.data.result[0]?.catalog || [];
      dispatch({
        type: GET_ITEMS_CATALOG,
        payload: rawCatalog,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_ITEMS_CATALOG,
      payload: [],
    });
    console.error(error);
  }
};

export const updateCartItemAction = (updatedItem) => (dispatch) => {
  dispatch({
    type: UPDATE_CART_ITEM_FULL,
    payload: updatedItem,
  });
};

export const saveOrderAction = (data) => async (dispatch) => {
  try {
    dispatch({ type: LICENSE_LOADING_SAVE_ORDER, payload: true });
    dispatch({ type: LICENSE_SAVE_ORDER_SUCCESS, payload: false });
    dispatch({ type: SAVE_ORDER_MARKET_ERROR, payload: null });

    const config = defaultHeadersMarket();
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/cart/create-order`,
      data, config,
    );
    if (response.status === 200) {
      sessionStorage.removeItem('cart_promos');
      dispatch({ type: LICENSE_SAVE_ORDER_SUCCESS, payload: true });
      dispatch({ type: SAVE_ORDER_SUCCESS, payload: response?.data?.result });
    }
    dispatch({ type: LICENSE_LOADING_SAVE_ORDER, payload: false });
  } catch (error) {
    console.error(error);
    const errorMessage = error?.response?.data?.statusDetails?.[0]?.description
      || 'Hubo un problema al procesar el pago.';
    dispatch({ type: LICENSE_SAVE_ORDER_SUCCESS, payload: false });
    dispatch({ type: SAVE_ORDER_SUCCESS, payload: {} });
    dispatch({ type: LICENSE_LOADING_SAVE_ORDER, payload: false });
    dispatch({
      type: SAVE_ORDER_MARKET_ERROR,
      payload: errorMessage,
    });
  }
};

export const cartAddEmergencyAction = (data) => () => {
  fetch(`${API_LICENCIAMIENTO}/license/api/cart/add`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('tokenAdminIbuho')}`,
    },
    body: JSON.stringify(data),
    keepalive: true,
  });
};

export const cartAddAction = (data) => async () => {
  try {
    const config = defaultHeadersMarket();
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/cart/add`,
      data, config,
    );
    if (response.status === 200) {}
  } catch (error) {
    console.error(error);
  }
};

export const setManualErrorAction = (tenant) => (dispatch, getState) => {
  const { general: { getParametersMarket } } = getState();
  let urlFromParams = null;
  let countryFromParams = null;
  if (Array.isArray(getParametersMarket) && getParametersMarket.length > 0) {
    const foundParam = getParametersMarket.find(
      (param) => param?.parameterCode === 'URL_Market_Tenant'
          && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
    );
    if (foundParam) {
      urlFromParams = foundParam.parameterValue;
    }
    const foundParamCountry = getParametersMarket.find(
      (param) => param?.parameterCode === 'COUNTRY_DEFAULT'
          && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
    );
    if (foundParamCountry) {
      countryFromParams = foundParamCountry?.parameterValue;
    }
  }
  const fallbackUrl = TENANT_LANDINGS[tenant];
  dispatch({
    type: GET_CART_ERROR,
    payload: { hasError: true, url: urlFromParams || fallbackUrl },
  });
  dispatch({
    type: SET_MARKET_CONTEXT,
    payload: {
      countryCode: countryFromParams,
    },
  });
};

export const saveProductsAssignmentsAction = (data) => async (dispatch) => {
  try {
    dispatch({ type: SAVING_ASSIGNMENTS_LOADING, payload: true });

    const config = defaultHeadersMarket();
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/license/purchase-product-assignments`,
      data, config,
    );
    if (response.status === 200) {
      dispatch({ type: SAVE_ASSIGNMENTS_SUCCESS, payload: true });
    }
  } catch (error) {
    dispatch({ type: SAVING_ASSIGNMENTS_LOADING, payload: false });
    console.error(error);
  }
};

export const sendToePaycoPaymentMarketAction = (token, documentType, documentNumber, code, paymentGateway, checkoutRedirectUrl) => async () => {
  try {
    if (paymentGateway === 'DLOCAL') {
      window.location.href = checkoutRedirectUrl;
    } else {
      const urlePaycoServices = `${EPAYCOPAYMENTSSERVICES}?paymentId=${code}&signToken=${token}&docType=${documentType}&docNumber=${documentNumber}`;
      window.location.href = urlePaycoServices;
    }
  } catch (error) {
    const { response } = error;
    console.error('Error al registrar pago.', response);
  }
};

export const getPaymentResultAction = (tenant, paymentCode) => async (dispatch, getState) => {
  if (tenant && paymentCode) {
    const config = defaultHeadersMarket();
    Object.assign(config.headers, {
      referenceUuid: paymentCode,
    });
    const { general: { getParametersMarket } } = getState();
    try {
      let countryFromParams = null;
      if (Array.isArray(getParametersMarket) && getParametersMarket.length > 0) {
        const foundParamCountry = getParametersMarket.find(
          (param) => param?.parameterCode === 'COUNTRY_DEFAULT'
            && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
        );
        if (foundParamCountry) {
          countryFromParams = foundParamCountry?.parameterValue;
        }
      }
      dispatch({
        type: SET_MARKET_CONTEXT,
        payload: {
          countryCode: countryFromParams,
        },
      });
      dispatch({ type: GET_CART_ERROR, payload: { hasError: false, url: null } });
      const response = await axios.get(
        `${API_LICENCIAMIENTO}/license/api/license/get-transaction-status`, config,
      );
      dispatch({
        type: PAYMENT_RESULT,
        payload: {
          statusCode: response?.data?.statusCode,
          succesfullMessage: 'Transacción finalizada',
          description: 'Revisa tu correo electrónico para continuar con el proceso.',
        },
      });
    } catch (error) {
      const urlFromBack = error.response?.data?.result?.urlMarketPlace;
      let urlFromParams = null;
      if (Array.isArray(getParametersMarket) && getParametersMarket.length > 0) {
        const foundParam = getParametersMarket.find(
          (param) => param?.parameterCode === 'URL_Market_Tenant'
            && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
        );
        if (foundParam) {
          urlFromParams = foundParam?.parameterValue;
        }
      }
      const urlFromConfig = TENANT_LANDINGS[tenant];
      if (error?.response?.data?.statusCode !== 422) {
        dispatch({
          type: GET_CART_ERROR,
          payload: { hasError: true, url: urlFromBack || urlFromParams || urlFromConfig },
        });
      } else {
        dispatch({
          type: PAYMENT_RESULT,
          payload: {
            statusCode: 401,
            succesfullMessage: 'error',
            description: 'error',
          },
        });
      }
      const errorResult = error?.response?.data?.result;
      let countryFromParams = null;
      if (Array.isArray(getParametersMarket) && getParametersMarket.length > 0) {
        const foundParamCountry = getParametersMarket.find(
          (param) => param?.parameterCode === 'COUNTRY_DEFAULT'
            && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
        );
        if (foundParamCountry) {
          countryFromParams = foundParamCountry?.parameterValue;
        }
      }
      dispatch({
        type: SET_MARKET_CONTEXT,
        payload: {
          ...errorResult,
          countryCode: errorResult?.countryCode || countryFromParams,
        },
      });
    }
  }
};

export const applyPromotionalCodeAction = (newCode, alreadyApplied = []) => async (dispatch) => {
  try {
    dispatch({ type: LOADING_VALIDATE_PROMO_CODE, payload: true });
    dispatch({
      type: SET_PROMO_FEEDBACK,
      payload: { message: '', isError: false },
    });
    const config = defaultHeadersMarket();
    const data = {
      promoCode: newCode,
      appliedCodes: alreadyApplied,
    };
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/cart/apply-promotional-code`,
      data, config,
    );

    if (response.data.statusCode === 200) {
      dispatch({
        type: ADD_PROMO_TO_LIST,
        payload: response.data.result,
      });
      dispatch({
        type: SET_PROMO_FEEDBACK,
        payload: { message: 'Código promocional aplicado', isError: false },
      });
    } else {
      dispatch({
        type: SET_PROMO_FEEDBACK,
        payload: { message: 'El código promocional no es válido', isError: true },
      });
    }
    dispatch({ type: LOADING_VALIDATE_PROMO_CODE, payload: false });
  } catch (error) {
    dispatch({ type: LOADING_VALIDATE_PROMO_CODE, payload: false });
    dispatch({
      type: SET_PROMO_FEEDBACK,
      payload: { message: 'El código promocional no es válido', isError: true },
    });
    console.error('Error al aplicar código', error);
  }
};

export const TransactionPaymentStatusMarketAction = (transactionCode, transactionStatus, fullReference) => async (dispatch) => {
  try {
    const config = defaultHeadersMarket();
    const transactionPaymentStatusRequest = {
      transactionCode,
      transactionStatus,
      fullReference,
    };
    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/purchaseOrderLicense/TransactionPaymentStatus`, transactionPaymentStatusRequest, config);

    if (response.status === 200) {}
  } catch (error) {}
};

export const GetCountriesFlagsAction = () => async (dispatch) => {
  try {
    const config = defaultHeaders();
    const response = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/get-countries`, config);
    if (response.status === 200) {
      dispatch({
        type: COUNTRIES_FLAGS,
        payload: response.data.result,
      });
    }
  } catch (error) {
    console.error(error);
    const { response } = error;
    if (response.status === 404) {
      dispatch({
        type: COUNTRIES_FLAGS,
        payload: response.data,
      });
    }
  }
};

export const getCustomerAssignedContractsAction = (filterSearch) => async (dispatch, getState) => {
  try {
    const config = defaultHeaders();
    const filterRequest = {
      filterSearch,
    };
    const response = await axios.post(`${API_LICENCIAMIENTO}/license/api/customer/assigned-contracts`, filterRequest, config);
    if (response.status === 200) {
      dispatch({
        type: CUSTOMER_ASSIGNED_CONTRACTS,
        payload: response.data.result,
      });
    }
  } catch (error) {
    console.warn('Error obtaining customer assigned contracts ', error);

    dispatch({
      type: CUSTOMER_ASSIGNED_CONTRACTS,
      payload: [],
    });
  }

  return null;
};

export const getCustomerContractsAssignedUserAction = () => async (dispatch, getState) => {
  try {
    const config = defaultHeaders();

    const response = await axios.post(`${API_SEGURIDAD}/api/user/customer-assigned-contracts`, null, config);
    if (response.status === 200) {
      dispatch({
        type: CUSTOMER_ASSIGNED_CONTRACTS,
        payload: response.data.result,
      });
    }
  } catch (error) {
    console.warn('Error obtaining customer assigned contracts ', error);

    dispatch({
      type: CUSTOMER_ASSIGNED_CONTRACTS,
      payload: [],
    });
  }

  return null;
};

export const getCustomerEditInformationLicenseAction = (Idcustomer, docType, doc) => async (dispatch) => {
  try {
    dispatch({ type: LOADING_CUSTOMER_EDIT_INFORMATION, payload: true });
    const config = defaultHeaders();

    const data = {
      CustomerId: Idcustomer,
      DocumentNumber: doc.toString(),
      DocumentType: docType.toString(),
    };
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/Customer/GetCustomer`,
      data, config,
    );
    if (response.status === 200) {
      dispatch({
        type: GET_CUSTOMER_EDIT_INFORMATION_LICENSE,
        payload: response.data,
      });
      dispatch({ type: LOADING_CUSTOMER_EDIT_INFORMATION, payload: false });
    }
  } catch (error) {
    console.error(error);
    const { response } = error;
    if (response.status === 404) {
      dispatch({
        type: GET_CUSTOMER_EDIT_INFORMATION_LICENSE,
        payload: response.data,
      });
      dispatch({ type: LOADING_CUSTOMER_EDIT_INFORMATION, payload: false });
    }
  }
};

export const updateCustomerAction = (
  formData,
  geoCodeService,
  ImagePopup,
  WarningPopup,
) => async (dispatch) => {
  try {
    dispatch({ type: LICENSE_LOADING_UPDATE_CUSTOMER, payload: true });
    const customer = {
      customerId: formData.idCustomerEdit,
      personType: formData.personTypeService,
      documentTypeId: formData.documentTypeIdService,
      documentNumber: formData.documentNumberService,
      legalName: formData.personTypeService === 'J' ? formData.legalNameService : null,
      firstName: formData.firstNameService,
      lastName: formData.lastNameService,
      cellphoneNumber: formData.cellphoneNumberService,
      email: formData.emailService,
      fulladdress: getAddress(formData.fulladdressService),
      cityId: formData.cityIdService.id
        ? formData.cityIdService.id
        : formData.cityIdService,
      legalDocumentTypeId: formData.legalDocumentTypeIdService,
      legalDocumentNumber: formData.legalDocumentNumberService,
      legalFirstName: formData.legalFirstNameService,
      legalLastName: formData.legalLastNameService,
      dv: formData.dvService,
      addressAdditionalInformation: formData.additionalInfoService,
      addressLatGeocode: geoCodeService ? geoCodeService.lat : null,
      addressLngGeocode: geoCodeService ? geoCodeService.lng : null,
      TicketId: formData.ticketService,
      Observations: formData.observations,
    };

    const config = defaultHeaders();
    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/Customer/UpdateCustomer`,
      customer, config,
    );

    const responseOrder = response.data;

    if (response.status === 200) {
      dispatch({ type: LICENSE_LOADING_UPDATE_CUSTOMER, payload: false });
      dispatch(
        setMessageAlertAction({
          category: 'license',
          typeMsg: 'Success',
          tittleMsg: '¡Perfecto!',
          showTitle: false,
          img: ImagePopup,
          message: responseOrder.statusMessage,
          isOnlyMessage: true,
          autoHideAlert: true,
          showClose: false,
          showCloseAlert: false,
          showButtonCancel: true,
          popupStyle: { padding: '10%' },
          contentStyle: { display: 'grid', justifyItems: 'center' },
          styleMessage: { color: '#E45501', fontSize: 20 },
        }),
      );
    }
  } catch (error) {
    dispatch({ type: LICENSE_LOADING_UPDATE_CUSTOMER, payload: false });
    console.error(`Error al guardar el cliente: ${error.message}`);
    if (error.response) {
      dispatch(
        setMessageAlertAction({
          category: 'licenseError',
          typeMsg: 'Error',
          tittleMsg: 'Error',
          showTitle: false,
          textButtonAcept: 'Entendido',
          img: WarningPopup,
          message: 'No fue posible actualizar la empresa',
          showClose: false,
          showCloseAlert: false,
          popupStyle: { padding: '10%' },
          contentStyle: { display: 'grid', justifyItems: 'center' },
          styleMessage: { color: '#E45501', fontSize: 20 },
          subMensaje: 'Inténtelo nuevamente. Si el problema continúa, comuníquese con soporte.',
          handleAccept: () => { window.location.reload(); },
        }),
      );
    }
  }
};

export const contractAnnulmentAction = (data) => async (dispatch) => {
  try {
    dispatch({ type: LOADING_CONTRACT_ANNULMENT, payload: true });
    const config = defaultHeaders();

    const response = await axios.post(
      `${API_LICENCIAMIENTO}/license/api/contract/annulment`,
      data, config,
    );
    if (response.status === 200) {
      dispatch({
        type: CONTRACT_ANNULMENT,
        payload: response.data.result,
      });
      dispatch({ type: LOADING_CONTRACT_ANNULMENT, payload: false });
    }
  } catch (error) {
    console.error(error);
    const { response } = error;
    if (response.status === 404) {
      dispatch({
        type: CONTRACT_ANNULMENT,
        payload: response.data,
      });
      dispatch({ type: LOADING_CUSTOMER_EDIT_INFORMATION, payload: false });
    }
  }
};
